import { ThresholdBandConfig } from '../../data/charts/plugins/chartjs-plugin-threshold-bands';

// Corrosion-rate (icorr, µA/cm²) risk bands — RILEM / Andrade & Alonso interpretation.
// Shared by the SHM measurement view and the compare tool.
//   <= 0.1 negligible (transparent) · 0.1–0.5 low (amber) · 0.5–1.0 moderate (orange) · > 1.0 high (red)
export const SHM_ICORR_THRESHOLD_BANDS: ThresholdBandConfig = {
  bands: [
    { from: 0,   color: 'rgba(0, 0, 0, 0)' },                                    // none
    { from: 0.1, color: 'rgba(234, 179, 8, 0.10)', label: 'Bajo riesgo' },       // amber
    { from: 0.5, color: 'rgba(249, 115, 22, 0.10)', label: 'Riesgo moderado' },  // orange
    { from: 1,   color: 'rgba(239, 68, 68, 0.09)', label: 'Riesgo alto' },       // red
  ],
  extendAxis: true,
};
